/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProxyProfileMini
 */
export interface ProxyProfileMini {
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileMini
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileMini
     */
    name: string;
}

export function ProxyProfileMiniFromJSON(json: any): ProxyProfileMini {
    return ProxyProfileMiniFromJSONTyped(json, false);
}

export function ProxyProfileMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyProfileMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function ProxyProfileMiniToJSON(value?: ProxyProfileMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


